export const env = {
    endpoint: location.protocol + '//' + process.env.REACT_APP_ENDPOINT
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/env/index.ts